import api from "@/lib/api";

export function applySpellMatch(text, match, replacement) {
  const offset = Number(match?.offset) || 0;
  const length = Number(match?.length) || 0;
  if (!replacement || offset < 0 || length <= 0) return text;
  return `${text.slice(0, offset)}${replacement}${text.slice(offset + length)}`;
}

export function applyAllSpellMatches(text, matches) {
  let out = String(text || "");
  const ordered = [...(matches || [])].sort((a, b) => (b.offset || 0) - (a.offset || 0));
  ordered.forEach((match) => {
    const replacement = match.replacements?.[0];
    if (replacement) out = applySpellMatch(out, match, replacement);
  });
  return out;
}

export async function checkSpanishSpelling(text) {
  const { data } = await api.post("/system/spellcheck", { text });
  return data;
}

export function parseSpellcheckError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail.trim();
  return "No se pudo revisar la ortografía.";
}
